import { DCUIContent } from '@iddataweb/idw-common-ui/types';
import { SanitizedHtmlContainer } from '@iddataweb/idw-common-ui/containers';
import { DCUIThemingLoadingSpinner } from "../dcui-theming-loading-spinner/dcui-theming-loading-spinner";
import styles from "./dcui-theming-complete-page.less";

type DCUIThemingCompletePageProps = {
    dcuiContent: DCUIContent;
    showUploadInProgress: boolean;
    showRedirectMessage: boolean;
    showUploadErrorMessage: boolean;
};

export const DCUIThemingCompletePage = (props: DCUIThemingCompletePageProps) => {
    const {
        dcuiContent,
        showUploadInProgress,
        showRedirectMessage,
        showUploadErrorMessage
    } = props;

    const captureUploadInProgressTitle = dcuiContent.captureComplete.captureUploadTitle;
    const captureUploadCompleteTitle = dcuiContent.captureComplete.captureUploadCompleteTitle;
    const captureUploadErrorMessage = dcuiContent.captureComplete.captureUploadErrorMessage;
    const captureSuccessNoRedirectMessage = dcuiContent.captureComplete.captureSuccessNoRedirectMessage;
    const captureSuccessMessage = dcuiContent.captureComplete.captureSuccessMessage;

    return (
        <div className={styles.dcuiThemingCompletePage}>
            {(showUploadInProgress) && (
                <div className={styles.titleContainer}>
                    <h1>{captureUploadInProgressTitle}</h1>
                    <DCUIThemingLoadingSpinner loadingText={null} />
                </div>
            )}
            {!showUploadInProgress && (
                <>
                    <div className={styles.titleContainer}>
                        <h1>{captureUploadCompleteTitle}</h1>
                    </div>
                    <div>
                        {showUploadErrorMessage && (
                            <SanitizedHtmlContainer html={`<span>${captureUploadErrorMessage}</span>`} />
                        )}
                        {!showUploadErrorMessage && !showRedirectMessage && (
                            <SanitizedHtmlContainer html={`<span>${captureSuccessNoRedirectMessage}</span>`} />
                        )}
                        {!showUploadErrorMessage && showRedirectMessage && (
                            <SanitizedHtmlContainer html={`<span>${captureSuccessMessage}</span>`} />
                        )}
                    </div>
                </>
            )}
        </div>
    )
};